<template>
  <div>
    <van-nav-bar title="设置" left-arrow @click-left="$router.go(-1)" />
    <van-cell title="手机号" :value="userInfo.username" />
    <van-cell
      title="用户昵称"
      :value="userInfo.nickname"
      is-link
      to="/changeName"
    />
    <van-cell title="支付宝" is-link to="/alipay" />
    <van-cell title="修改密码" is-link to="/editPwd" />
    <van-cell title="退出登录" is-link @click="exit" />
  </div>
</template>


<script>
export default {
  data() {
    return {
      userInfo: {},
    };
  },
  created() {
    this.Post({}, "/main/userinfo", (res) => {
      if (res.states == 1) {
        this.userInfo = res.data;
      } else if (res.states == 400) {
        this.$router.replace("/login");
      } else {
        this.Toast.fail(res.msg);
      }
    });
  },
  methods: {
    // 退出登录
    exit() {
      this.Post({}, "/main/userexit", (res) => {
        if (res.states == 1) {
          window.localStorage.setItem("userInfo",'')
          this.$store.dispatch("setUser", {});
          this.$router.push("/user");
        } else {
          this.Toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/mine/set.vue